<script>
import { h, ref, toRef } from 'vue'
import { useDisabled } from '../hook/use-disabled'
import { useShow } from '../hook/use-show'
export default {
  inheritAttrs: false,
  props: {
    action: Function,
    menu: Object,
    compileData: Object,
    title: String,
  },
  setup(props, { attrs, slots }) {
    const loading = ref(false)
    const compile = toRef(props, 'compileData')
    const { disabled } = useDisabled(compile, props.menu)
    const { show } = useShow(compile, props.menu)
    return () =>
      !show.value
        ? null
        : h(
            'ElButton',
            {
              attrs: { title: props.title },
              props: {
                ...attrs,
                disabled: disabled.value,
                icon: props.menu?.icon,
                loading: loading.value,
              },
              on: {
                click: async () => {
                  try {
                    loading.value = true
                    await props.action?.(props.menu, props.compileData)
                    loading.value = false
                  } catch (e) {
                    loading.value = false
                    console.error(e)
                  }
                },
              },
            },
            [slots.default()]
          )
  },
}
</script>
